import { reducers } from 'redux/core'
import request from 'sb-request'
import { constants } from 'common/helpers'
import { getFeatureToggle } from 'helpers'


const restFetch = () =>
  request.get('rest/vacancies')

const gqlFetch = () =>
  request.post('graphql?name=vacancies', {
    body: {
      query: `{
        vacancies {
          id
          title
          description
          location
          department
          link
          status
          dateCreated
          lastUpdated
        }
      }`,
    },
    modifyResult: ({ vacancies }) => (vacancies || []),
  })

const fetch = () => (
  getFeatureToggle(constants.gqlFeatures.vacanciesGQL) ? gqlFetch() : restFetch()
)
  .then((result) => {
    reducers.view.careersPage.setVacancies(result)
    return result
  })


export default {
  fetch,
}
